/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState, useCallback, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Spinner,
  Form,
  InputGroup,
  Alert,
} from "react-bootstrap";
import { PrismicRichText } from "@prismicio/react";
import Turnstile from "react-turnstile";
import { linkResolver } from "../../utilities/prismic-linkResolver";

import "../../styles/components/slices/newsletter.scss";

const Newsletter = ({ slice }) => {
  if (!slice) return null;
  const { title1, btn_label, subtitle, terms } = slice.primary;

  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState();
  const [validated, setValidated] = useState(false);
  const validMessage = "Παρακαλώ συμπληρώστε αυτό το πεδίο!";
  const messageSucess = "Σας ευχαριστούμε για το μήνυμά σας.";
  const messageError = "Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε ξανά αργότερα.";

  // Create a ref for the section to scroll to
  const sectionRef = useRef(null);

  const scrollToSection = () => {
    // Use scrollIntoView to scroll to the section
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  };

  const onSubmit = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.currentTarget.checkValidity() === false) {
      setValidated(true);
      return;
    }

    setLoading(true);

    fetch("/api/forms/submit", {
      method: "POST",
      body: new FormData(e.target),
    })
      .then((res) => res.json())
      .then((res) => {
        const { success } = res;

        if (success) {
          e.target.reset();
          setSubmitStatus({
            message: messageSucess,
            type: "success",
          });
        } else {
          setSubmitStatus({
            message: messageError,
            type: "danger",
          });
        }
      })
      .catch(() => {
        setSubmitStatus({
          message: "Something went wrong.",
          type: "danger",
        });
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <Container
      id="newsletter-section"
      fluid
      className="newsletter_section"
      style={{
        backgroundColor: "#EEF2FB",
      }}
      ref={sectionRef}
    >
      <Container className=" max-container">
        <Row className="justify-content-center text-center">
          <Col md={8}>
            <h2 className="fw-light mb-4 fs-35">{title1.text}</h2>
            <p>{subtitle}</p>
            <Form
              className="newsletter-form mx-md-2"
              onSubmit={onSubmit}
              name="newsletter-form"
              // noValidate
              // validated={validated}
            >
              <input type="hidden" name="type" value="newsletter" />
              <input type="hidden" name="Form" value="SM2 Form" />

              <InputGroup className="mb-3 position-relative">
                <Form.Label visuallyHidden="true">E-mail</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="E-mail"
                  name="Email"
                  required
                />

                <Button
                  type="submit"
                  // disabled={disable || loading}
                  className="d-block mx-auto"
                  variant="secondary"
                >
                  {btn_label}
                  {loading && (
                    <Spinner animation="border" size="sm" className="ms-2" />
                  )}
                </Button>
              </InputGroup>

              <Form.Group
                className="mb-1 formBasicCheckbox"
                controlId="formBasicCheckbox"
              >
                <Form.Label className="d-flex align-items-center justify-content-center gap-2 position-relative text-start">
                  <Form.Check
                    type="checkbox"
                    name="Terms"
                    value="accepted"
                    required
                    feedback="Πρέπει να συμφωνήσετε πριν την υποβολή."
                    feedbackType="invalid"
                  />

                  <div
                    className="rte slab-400 text-start"
                    style={{ fontSize: "13px" }}
                  >
                    <PrismicRichText
                      field={terms.richText}
                      linkResolver={linkResolver}
                    />
                  </div>
                </Form.Label>
              </Form.Group>

              <Turnstile
                sitekey={process.env.GATSBY_TURNSTILE_SITE_KEY}
                theme="dark"
                onError={() => setDisable(true)}
                onExpire={() => setDisable(true)}
                onVerify={() => setDisable(false)}
                className="mb-2"
              />
            </Form>
            {submitStatus && (
              <Alert
                variant={submitStatus.type}
                className="my-3 text-center"
                onClose={() => setSubmitStatus()}
                dismissible
              >
                {submitStatus.message}
              </Alert>
            )}
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Newsletter;
